import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { db } from "@/firebase";
import { addDoc, collection, deleteDoc, doc, getDocs, serverTimestamp } from "firebase/firestore";
import { addLoadingTask, deleteLoadingTask } from "@/store/uiSlice";
import { RootState } from "@/store/store";
import { OrgCategory } from "@/types";
import { addOrganizationCategories } from "../slice";

export const orgCategoriesApi = createApi({
    reducerPath: "orgCategories",
    baseQuery: fakeBaseQuery(),
    tagTypes: ["OrgCategories"],
    endpoints: (builder) => ({
      fetchOrgCategories: builder.query({
        queryFn: async (organizationId: string, { dispatch }) => {
            const TASK = "Categorías";

            if (!organizationId) {
              return { data: [] };
            }

            try {
                dispatch(addLoadingTask(TASK));
                const collectionRef = collection(db, `organizations/${organizationId}/categories`);

                const response = await getDocs(collectionRef).then((querySnapshot) => {
                    return querySnapshot.docs.reduce((acc, doc: any) => {
                        return [...acc, {...doc.data(), id: doc.id}];
                    }, [] as OrgCategory[]);
                });

                if (response?.length) {
                  dispatch (addOrganizationCategories({ organizationId, categories: response } ))
                }

                return { data: response};
            } catch (error) {
                return { error };
            } finally {
                dispatch(deleteLoadingTask(TASK));
            }
        },
        providesTags: ["OrgCategories"],
      }),

      addOrganizationCategory: builder.mutation({
        queryFn: async ({ organizationId, payload }: { organizationId: string; payload: Pick<OrgCategory, 'title'> }, { getState }) => {
          try {
            const { auth } = getState() as RootState;
      
            if (!auth?.user?.uid) {
              return { data: undefined };
            }

            const draft: OrgCategory = {
              ...payload,
              createdBy: auth.user.uid,
              createdAt: serverTimestamp(),
            };
      
            const collectionRef = collection(db, `organizations/${organizationId}/categories`);
            const response = await addDoc(collectionRef, draft);
            return { data: response };
          } catch (error) {
            return { error };
          }
        },
        invalidatesTags: ["OrgCategories"],
      }),
      
      deleteOrganizationCategory:  builder.mutation({
        queryFn: async ({ organizationId, categoryId }: { organizationId: string; categoryId: string }) => {
          try {
            const collectionRef = doc(db, `organizations/${organizationId}/categories/${categoryId}`);
            const response = await deleteDoc(collectionRef);
            return { data: response };
          } catch (error) {
            return { error };
          }
        },
        invalidatesTags: ["OrgCategories"],
      }),
    }),
});

export const { 
  useFetchOrgCategoriesQuery, 
  useAddOrganizationCategoryMutation, 
  useDeleteOrganizationCategoryMutation,
} = orgCategoriesApi;


